import { getEnvSuffix, getGuestSiteLink, isDesktopApp, getEnvDomain, getSupportLink, getSamplesLink, getNetworkLink, getEducationLink, getSessionsLink } from '@landr/core';
export { getEducationLink, getEnvDomain, getEnvSuffix, getGuestSiteLink, getNetworkLink, getSamplesLink, getSessionsLink, getSupportLink } from '@landr/core';
import { Links } from '../enums/Links.es.js';

var isBrowser = typeof window !== 'undefined';
var blogUrlRegex = /blog-?[a-z]*\.landr\.com/;
var networkUrlRegex = /network-?[a-z]*\.landr\.com/;
var pluginsMarketPlaceUrlRegex = /^plugins(-(dev|demo|partner))?\.landr\.com/;
var samplesUrlRegex = /^samples(-(dev|demo|partner))?\.landr\.com/;
var webAppUrlRegex = /app-?[a-z]*\.landr\.com/;
var navigateHandler = function navigateHandler(path) {
  var currentPort = isBrowser ? window.location.port : '';
  var currentHostname = isBrowser ? window.location.hostname : '';
  var url = new URL(path);
  var isCurrentHostAndPort = currentHostname === url.hostname && currentPort === url.port;
  // When already in Plugins or Samples, using window.history.pushState doesn't register the page changes.
  var isUnsupportedHostname = currentHostname.includes('plugins') || currentHostname.includes('samples');
  if (isCurrentHostAndPort && !isUnsupportedHostname) {
    window.history.pushState({}, '', path);
  } else {
    window.open(path, getWindowTarget(url));
  }
};
function getWindowTarget(url) {
  var currentHostname = isBrowser ? window.location.hostname : '';

  // Open network, plugins marketplace and samples in current tab even on desktop app
  if (networkUrlRegex.test(url.hostname) || pluginsMarketPlaceUrlRegex.test(url.hostname) || samplesUrlRegex.test(url.hostname)) {
    return '_self';
  }

  // When on another app than web app and navigating back to it
  if ((networkUrlRegex.test(currentHostname) || blogUrlRegex.test(currentHostname) || samplesUrlRegex.test(currentHostname) || pluginsMarketPlaceUrlRegex.test(currentHostname)) && webAppUrlRegex.test(url.hostname)) {
    return '_self';
  }

  // Open blog in new tab
  if (blogUrlRegex.test(url.hostname)) {
    return '_blank';
  }
  return isDesktopApp() || !url.hostname.includes('landr.com') ? '_blank' : '_self';
}
var openLink = function openLink(link) {
  navigateHandler(link);
};
var getWebAppLink = function getWebAppLink(env) {
  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  var currentHost = isBrowser ? window.location.host : '';
  // Check the port too as other apps could run in local (plugins, samples, network)
  var isOnLocalWebapp = currentHost && currentHost.match(/^local.landr.com:9102$/);
  if (isOnLocalWebapp) {
    return "https://local.landr.com:9102".concat(pathname);
  } else {
    return "https://app".concat(getEnvSuffix(env), ".landr.com").concat(pathname);
  }
};
var getWebAppLinkLibraryOrMasteringPreview = function getWebAppLinkLibraryOrMasteringPreview(env, isLoggedOut) {
  var pathname = isLoggedOut ? "".concat(Links.Library, "/masteringPreview") : Links.Library;
  return getWebAppLink(env, pathname);
};
var openWebAppLink = function openWebAppLink(env) {
  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  openLink(getWebAppLink(env, pathname));
};
var openSupportLink = function openSupportLink(language) {
  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  openLink(getSupportLink(language, pathname));
};
var openGuestSiteLink = function openGuestSiteLink(env) {
  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  openLink(getGuestSiteLink(env, pathname));
};
var getPluginsLink = function getPluginsLink(env) {
  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  return getWebAppLink(env, "/plugins".concat(pathname));
};
var openPluginsLink = function openPluginsLink(env) {
  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  openLink(getPluginsLink(env, pathname));
};
var getRedeemAProductLink = function getRedeemAProductLink(env) {
  return "https://redeem".concat(getEnvDomain(env));
};
var openRedeemAProductLink = function openRedeemAProductLink(env) {
  openLink(getRedeemAProductLink(env));
};
var openSamplesLink = function openSamplesLink(env) {
  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  return openLink(getSamplesLink(env, pathname));
};
var getSessionsAboutLink = function getSessionsAboutLink(env) {
  return "".concat(getWebAppLink(env), "sessions#about");
};
var openSessionsLink = function openSessionsLink(env) {
  return openLink(getSessionsLink(env));
};
var openSessionNewRoomLink = function openSessionNewRoomLink(env) {
  return openWebAppLink(env, '/sessions/rooms/new');
};
var openNetworkLink = function openNetworkLink(env) {
  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return openLink(getNetworkLink(env, pathname));
};
var getBlogLink = function getBlogLink(env) {
  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return "https://blog".concat(getEnvDomain(env)).concat(pathname);
};
var openHomeLink = function openHomeLink(env) {
  openWebAppLink(env, '/dashboard');
};
var openEducationLink = function openEducationLink(env) {
  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  return openLink(getEducationLink(env, pathname));
};

export { getBlogLink, getPluginsLink, getRedeemAProductLink, getSessionsAboutLink, getWebAppLink, getWebAppLinkLibraryOrMasteringPreview, navigateHandler, openEducationLink, openGuestSiteLink, openHomeLink, openLink, openNetworkLink, openPluginsLink, openRedeemAProductLink, openSamplesLink, openSessionNewRoomLink, openSessionsLink, openSupportLink, openWebAppLink };
